import { handleResponse } from "../../../helpers/handleresponse";
import { authHeader } from "../../../helpers/authHeader";

export const pageService = {
  update,
  get,
  checkForUpdates,
  getAllPaths,
  screenshot
};

async function get(pageId, viewMode) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({ "Content-Type": "application/json" })
  };
  return fetch(`./api/page/${pageId}/?viewMode=${viewMode}`, requestOptions)
    .then(handleResponse)
    .then(page => {
      return page;
    });
}
async function getAllPaths(eventId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({ "Content-Type": "application/json" })
  };
  return fetch(`./api/page/getAllPaths/${eventId}`, requestOptions)
    .then(handleResponse)
    .then(pages => {
      return pages;
    });
}
async function screenshot(pageId){
  const requestOptions = {
    method: "POST",
    headers: authHeader({ "Content-Type": "application/json" }),
  };

  return fetch(`/files/pagescreenshot/${pageId}`, requestOptions)
    .then(handleResponse);
}
async function checkForUpdates(pageId, lastModified) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({ "Content-Type": "application/json" })
  };
  return fetch(`./api/page/checkforupdates/${pageId}/?lastModified=${lastModified}`, requestOptions)
    .then(handleResponse)
    .then(lastModified => {
      return lastModified;
    });
}

async function update(page) {

  const requestOptions = {
    method: "PUT",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(page)
  };

  return fetch(`./api/page`, requestOptions)
    .then(handleResponse)
    .then(page => {
      return page;
    });
}
